import React, { useEffect } from 'react';

export default function BrochurePage() {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  const brochures = [
    {
      id: 1,
      title: "Company Profile",
      description: "Learn about our company history and services",
      path: "/pdfs/pdf_01.pdf",
      coverImage: "/assets/cprofile.png",
    },
    {
      id: 2,
      title: "Kitchen Containers",
      description: "Browse our full range of catering equipment",
      path: "/pdfs/pdf_02.pdf",
      coverImage: "/assets/ckitchens.png",
    },
    {
      id: 3,
      title: "Custom Display Showcase",
      description: "Technical specifications and installation",
      path: "/pdfs/pdf_03.pdf",
      coverImage: "/assets/cshowcase.png",
    },
  ];

  const handleDownload = (brochure) => {
    // Create a temporary link to trigger download
    const link = document.createElement('a');
    link.href = brochure.path;
    link.download = `${brochure.title}.pdf`; // Suggest filename for download
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Optionally open in new window for viewing
    const newWindow = window.open(brochure.path, '_blank', 'noopener,noreferrer');
    if (newWindow) {
      newWindow.onload = function () {
        try {
          newWindow.document.title = `${brochure.title} - Northern Professional`;
          const favicon = newWindow.document.createElement('link');
          favicon.type = 'image/x-icon';
          favicon.rel = 'shortcut icon';
          favicon.href = './assets/npke_logo.png';
          newWindow.document.head.appendChild(favicon);
        } catch (e) {
          console.log('Unable to modify new window:', e);
        }
      };
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 py-16">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-4xl font-bold text-center text-indigo-900 mb-4">
          Download Our Brochures
        </h2>
        <p className="text-center text-gray-600 mb-12 max-w-2xl mx-auto">
          Explore our collection of brochures to learn more about our products and services.
          Download or view each brochure to discover what Northern Professional has to offer.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {brochures.map((brochure) => (
            <div
              key={brochure.id}
              className="bg-white rounded-xl shadow-lg overflow-hidden transform hover:scale-100 transition-transform duration-300"
            >
              {/* Brochure Cover Image */}
              <div className="relative">
                <img
                  src={brochure.coverImage}
                  alt={`${brochure.title} cover`}
                  className="w-full h-64 object-fit "
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <h3 className="absolute bottom-4 left-4 text-white text-xl font-semibold">
                  {brochure.title}
                </h3>
              </div>
              {/* Content */}
              <div className="p-6">
                <p className="text-gray-600 mb-6">{brochure.description}</p>
                <div className="flex space-x-4">
                  <button
                    onClick={() => handleDownload(brochure)}
                    className="flex-1 py-3 bg-indigo-900 text-white font-medium rounded-lg hover:bg-indigo-800 transition-colors flex items-center justify-center"
                  >
                    <svg
                      className="w-5 h-5 mr-2"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                      />
                    </svg>
                    Download
                  </button>
                  <button
                    onClick={() => window.open(brochure.path, '_blank', 'noopener,noreferrer')}
                    className="flex-1 py-3 bg-gray-200 text-gray-800 font-medium rounded-lg hover:bg-gray-300 transition-colors flex items-center justify-center"
                  >
                    <svg
                      className="w-5 h-5 mr-2"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                      />
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                      />
                    </svg>
                    View
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}